if (!customElements.get('poster-size-picker')) {
  customElements.define(
    'poster-size-picker',
    class PosterSizePicker extends HTMLElement {
      connectedCallback() {
        this.values = this.querySelector('.mp-option-values--poster');
        if (!this.values) return;

        this.organizeChoices();

        if (!this.hasToggleHandler) {
          this.addEventListener('click', (event) => {
            if (!event.target.closest('.mp-size-toggle')) return;
            this.toggleChoices();
          });
          this.hasToggleHandler = true;
        }
      }

      organizeChoices() {
        const preferredSizes = ['8x10', '11x14', '12x16', '16x20', '18x24', '24x36'];
        const choices = [...this.values.querySelectorAll('label')].map((label) => ({
          input: this.values.querySelector(`#${CSS.escape(label.htmlFor)}`),
          label,
          size: this.extractSize(label.textContent),
        }));

        const preferred = [];
        const extra = [];

        choices.forEach((choice) => {
          const rank = preferredSizes.indexOf(choice.size);
          choice.rank = rank;
          (rank === -1 ? extra : preferred).push(choice);
        });

        preferred.sort((a, b) => a.rank - b.rank);

        [...preferred, ...extra].forEach((choice) => {
          const isExtra = choice.rank === -1;
          const isSelected = Boolean(choice.input?.checked);

          choice.input?.classList.toggle('mp-size-choice--extra', isExtra);
          choice.label.classList.toggle('mp-size-choice--extra', isExtra);
          choice.input?.classList.toggle('mp-size-choice--selected', isSelected);
          choice.label.classList.toggle('mp-size-choice--selected', isSelected);

          if (choice.input) this.values.append(choice.input);
          this.values.append(choice.label);
        });
      }

      extractSize(text) {
        const normalized = text
          .toLowerCase()
          .replace(/[×]/g, 'x')
          .replace(/[“”″\"]/g, '')
          .replace(/\s+/g, '');
        const imperialPart = normalized.includes('/') ? normalized.split('/').pop() : normalized;
        return imperialPart.match(/\d+(?:\.\d+)?x\d+(?:\.\d+)?/)?.[0] || '';
      }

      toggleChoices() {
        const toggle = this.querySelector('.mp-size-toggle');
        if (!toggle) return;

        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.querySelector('[data-collapsed-label]').hidden = expanded;
        toggle.querySelector('[data-expanded-label]').hidden = !expanded;
        this.toggleAttribute('data-expanded', expanded);
      }
    },
  );
}

if (!window.MisfitPrintsPosterVariantAvailability) {
  window.MisfitPrintsPosterVariantAvailability = true;

  const syncPosterSubmitButton = () => {
    const productInfo = document.querySelector('product-info[data-template-suffix="poster"]');
    const selectedVariant = productInfo?.querySelector('variant-selects [data-selected-variant]')?.textContent;
    if (!selectedVariant) return;

    let variant;
    try {
      variant = JSON.parse(selectedVariant);
    } catch (error) {
      return;
    }

    const submitButton = productInfo.querySelector('button[name="add"]');
    if (!submitButton) return;
    submitButton.toggleAttribute('disabled', !variant.available);
    if (variant.available) submitButton.removeAttribute('aria-disabled');
  };

  document.addEventListener('change', (event) => {
    if (!event.target.closest('product-info[data-template-suffix="poster"] variant-selects')) return;
    [0, 400, 1200].forEach((delay) => window.setTimeout(syncPosterSubmitButton, delay));
  });
}
